import { fetchPath } from '../../utils/api'
import actionsFactory from './actions'

/**
 * Comments vuex module.
 */
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: actionsFactory({ fetchPath }),
}
